document.addEventListener("DOMContentLoaded", () => {
  const bar = document.getElementById("sticky-atc");
  if (!bar) return;

  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (!productForm) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        var rect = entry.boundingClientRect || {};
        // Show sticky bar only when the user has scrolled past the add to cart
        var scrolledPast =
          rect.bottom !== undefined ? rect.bottom <= 0 : !entry.isIntersecting;
        if (scrolledPast) {
          bar.classList.add("sticky-atc--visible");
        } else {
          bar.classList.remove("sticky-atc--visible");
        }
      });
    },
    { threshold: 0 },
  );

  // Start observing only after the page has fully loaded (images/CSS/layout stable)
  // This prevents an initial, incorrect intersection entry from briefly showing
  // the sticky bar during early paint on mobile devices.
  const startObserving = () => {
    try {
      // IntersectionObserver delivers an initial entry asynchronously with the correct
      // state, so no synchronous getBoundingClientRect() here (that forced a reflow).
      observer.observe(productForm);
    } catch (e) {
      // ignore
    }
  };

  if (document.readyState === "complete") {
    startObserving();
  } else {
    window.addEventListener("load", startObserving, { once: true });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const stickyButton = document.querySelector("#sticky-atc button");
  const productForm = document.querySelector('form[action*="/cart/add"]');
  const mainSubmitButton = productForm?.querySelector('button[type="submit"]');

  if (stickyButton && productForm) {
    stickyButton.addEventListener("click", (e) => {
      e.preventDefault();
      if (!mainSubmitButton) return;
      if (
        mainSubmitButton.hasAttribute("disabled") ||
        mainSubmitButton.getAttribute("aria-disabled") === "true"
      ) {
        return;
      }
      mainSubmitButton.click();
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // 1. Target by name="add" to avoid dynamic numeric IDs
  const mainAtcButton = document.querySelector('button[name="add"]');

  // 2. Target sticky button with correct DOUBLE underscores
  const stickyAtcButton = document.querySelector(
    ".sticky-atc__inner .button--primary",
  );

  if (mainAtcButton && stickyAtcButton) {
    const syncButtons = () => {
      // Sync Text content
      stickyAtcButton.textContent = mainAtcButton.textContent.trim();

      // Sync Disabled States
      // Based on your image, it uses both a 'disabled' class and aria-disabled="true"
      const isDisabled =
        mainAtcButton.hasAttribute("disabled") ||
        mainAtcButton.classList.contains("disabled") ||
        mainAtcButton.getAttribute("aria-disabled") === "true";

      if (isDisabled) {
        stickyAtcButton.setAttribute("disabled", "disabled");
        stickyAtcButton.setAttribute("aria-disabled", "true");
        stickyAtcButton.classList.add("disabled");
      } else {
        stickyAtcButton.removeAttribute("disabled");
        stickyAtcButton.setAttribute("aria-disabled", "false");
        stickyAtcButton.classList.remove("disabled");
      }
    };

    // Run once on load
    syncButtons();

    // Create observer to watch for text AND attribute changes
    const observer = new MutationObserver(syncButtons);

    observer.observe(mainAtcButton, {
      childList: true, // Watches text changes
      subtree: true, // Watches nested spans
      attributes: true, // Watches for class/disabled changes
      attributeFilter: ["class", "disabled", "aria-disabled"],
    });
  }
});

function getSelectedOptions(data) {
  const values = data?.data?.selectedOptionValues;

  if (!Array.isArray(values)) return [];

  // These are already option values (UUID-style), not objects
  return values;
}

function isVisible(el) {
  if (!el) return false;

  // not in DOM
  if (!document.documentElement.contains(el)) return false;

  const style = window.getComputedStyle(el);
  if (
    style.display === "none" ||
    style.visibility === "hidden" ||
    style.opacity === "0"
  )
    return false;

  // element (or ancestor) removed from layout
  if (el.offsetWidth === 0 && el.offsetHeight === 0) return false;

  // also check bounding rect in case of transforms / clipping
  const rect = el.getBoundingClientRect();
  if (rect.width === 0 && rect.height === 0) return false;

  return true;
}

function updateStickyATC(data) {
  var variant = data?.data?.variant;
  const sectionId = data?.data?.sectionId || "";

  const priceEl = document.querySelector(".sticky-atc__price");
  const compareEl = document.querySelector(".sticky-atc__compare");
  const stickyBtn = document.querySelector(".sticky-atc button");
  const mainSubmitButton = document.getElementById(
    `ProductSubmitButton-${sectionId}`,
  );
  const salePriceEl = [
    ...document.querySelectorAll(".price-item--sale.price-item--last"),
  ].find(isVisible);

  if (variant) {
    if (salePriceEl) {
      priceEl.textContent = salePriceEl?.innerHTML?.trim() || "";
    } else if (priceEl) {
      priceEl.textContent = formatMoneyCents(variant.price);
    }

    if (compareEl) {
      if (variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoneyCents(variant.compare_at_price);
        compareEl.style.display = "inline";
      } else {
        compareEl.style.display = "none";
      }
    }
  }

  if (stickyBtn && mainSubmitButton) {
    const mainLabel =
      mainSubmitButton.querySelector("span")?.textContent?.trim() ||
      mainSubmitButton.textContent?.trim() ||
      "Add to cart";
    const mainDisabled =
      mainSubmitButton.hasAttribute("disabled") ||
      mainSubmitButton.getAttribute("aria-disabled") === "true" ||
      mainSubmitButton.classList.contains("disabled");

    stickyBtn.textContent = mainLabel;
    stickyBtn.disabled = mainDisabled;
    stickyBtn.classList.toggle("disabled", mainDisabled);
  }
}

subscribe(PUB_SUB_EVENTS.variantChange, (data) => {
  updateStickyATC(data);
});

// Run layout-reading work (isVisible() uses getComputedStyle/offsetWidth/getBoundingClientRect)
// after the first frame has rendered, when layout is clean, so it doesn't force a synchronous reflow.
function afterFirstPaint(fn) {
  requestAnimationFrame(() => setTimeout(fn, 0));
}

function initStickyPrice() {
  const regularPriceEl = [
    ...document.querySelectorAll(".price-item.price-item--regular"),
  ].find((el) => isVisible(el));
  //const salePriceEl = document.querySelector("span.price-item:nth-child(4)");
  const salePriceEl = [
    ...document.querySelectorAll(".price-item--sale.price-item--last"),
  ].find(isVisible);

  const regularPrice = regularPriceEl?.innerHTML?.trim() || "";
  const salePrice = salePriceEl?.innerHTML?.trim() || "";

  const stickyPriceEl = document.querySelector(".sticky-atc__price");
  const stickyCompareEl = document.querySelector(".sticky-atc__compare");

  if (!stickyPriceEl) return;

  if (salePrice) {
    // Product is discounted
    stickyPriceEl.innerHTML = salePrice; // main sale price

    if (stickyCompareEl) {
      stickyCompareEl.innerHTML = regularPrice;
      stickyCompareEl.style.display = "inline-block"; // show strike-through price
    }
  } else {
    // Product not on sale
    stickyPriceEl.innerHTML = regularPrice;

    if (stickyCompareEl) {
      stickyCompareEl.innerHTML = "";
      stickyCompareEl.style.display = "none"; // hide compare price container
    }
  }
}

document.addEventListener("DOMContentLoaded", () => afterFirstPaint(initStickyPrice));

function formatMoneyCents(priceInCents) {
  // Prefer Shopify.formatMoney if available (keeps shop formatting)
  if (window.Shopify && typeof Shopify.formatMoney === "function") {
    try {
      return Shopify.formatMoney(priceInCents);
    } catch (e) {
      // continue to fallback
    }
  }

  // priceInCents is expected to be an integer (e.g. 1299 => $12.99)
  const amount = (Number(priceInCents) || 0) / 100;

  // Try to detect shop currency from common meta tags
  const currency =
    document.querySelector('meta[property="og:price:currency"]')?.content ||
    document.querySelector('meta[name="currency"]')?.content ||
    document.querySelector('meta[name="shop-currency"]')?.content ||
    "USD";

  // Use browser Intl API - respects user's locale
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch (e) {
    // Last fallback: simple formatting
    return "$" + amount.toFixed(2);
  }
}
